import { css } from '@emotion/react';
import { ReactElement, useState } from 'react';

import { useSDK } from '../../app';
import { styled } from '../../styled';
import { Theme } from '../../theme/interface/detailed';
import { RatingIcon } from './ratingIcon';

type Interface = { className: string; scale: number };

const styles = css`
	display: flex;
`;

const Component = ({ className, scale }: Interface): ReactElement => {
	const { uiStateStore } = useSDK();
	const [[rating, mouseEntered], setStatus] = useState<[number, boolean]>([0, false]);

	return (
		<>
			<div className={className}>
				{new Array(scale).fill(undefined).map((_, i) => (
					<RatingIcon
						onMouseEnter={(): void => setStatus([i, true])}
						onMouseLeave={(): void => setStatus([0, false])}
						onClick={(): void => {
							uiStateStore.setRating(i + 1);
						}}
						key={i}
						filled={mouseEntered ? i - 1 < rating : i < (uiStateStore.rating || -Infinity)}
					/>
				))}
			</div>
		</>
	);
};

const RatingForm = styled(Component)(
	({
		theme: {
			ratingField: {
				containers: { ratingIconsContainer },
			},
		},
	}: {
		theme: Theme;
	}) => ratingIconsContainer,
	styles
);

export { RatingForm as RatingStars };
